(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function getOverflowList() {
    return document.querySelector('#header-component overflow-list');
  }

  function updateMobileMenuOverflow() {
    const overflowList = getOverflowList();
    if (!overflowList) return;

    if (MOBILE_QUERY.matches) {
      if (typeof overflowList.showAll === 'function') {
        overflowList.showAll();
      } else {
        overflowList.setAttribute('disabled', 'true');
      }

      return;
    }

    overflowList.removeAttribute('disabled');
  }

  function init() {
    updateMobileMenuOverflow();
    MOBILE_QUERY.addEventListener('change', updateMobileMenuOverflow);

    const header = document.querySelector('#header-component');
    if (!header) return;

    const observer = new MutationObserver(updateMobileMenuOverflow);
    observer.observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
